import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="residentProjects";

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}


export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function startShare(projectId){
  console.log("data:",projectId)
  return axios({
    url: `/ws/${moduleName}/startShare/${projectId}`,
    method: 'put'
  })
}

export function deleteById(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function saveNewLease(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveNewLease`,
    method: 'post',
    data:parameter
  })
}


export function saveProjectClose(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveProjectClose`,
    method: 'post',
    data:parameter
  })
}

export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function selectProjectStages() {
  return axios({
    url: `/ws/${moduleName}/selectProjectStages`,
    method: 'get',
  })
}



export function getProjectTeamUser(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/getProjectTeamUser/${id}`,
    method: 'get',
  })
}


export default {
  insert,
  update,
  startShare,
  deleteById,
  saveNewLease,
  saveProjectClose,
  selectProjectStages,
  getProjectTeamUser,
  selectAll,
  selectOne,
}